import axios from "axios";

const http = axios.create({
  baseURL: "https://it-service.wanorn.com/backend/api/",
  headers: {
    "Content-Type": "application/json"
  }
});

const token = localStorage.getItem("token");

if (token) {
  http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

/* interceptor */
http.interceptors.response.use(

  response => response,

  error => {

    if (error.response && error.response.status === 401) {

      localStorage.removeItem("token");
      localStorage.removeItem("user");

      window.location.href = "/login";

    }

    return Promise.reject(error);

  }

);

export default http;